import { render, staticRenderFns } from "./PlayerStatus.vue?vue&type=template&id=5a9d5832&scoped=true"
import script from "./PlayerStatus.vue?vue&type=script&lang=js"
export * from "./PlayerStatus.vue?vue&type=script&lang=js"
import style0 from "./PlayerStatus.vue?vue&type=style&index=0&id=5a9d5832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9d5832",
  null
  
)

export default component.exports